import { useWatch } from 'react-hook-form'

import { SEGMENT_PRICE_MODE_LABELS } from '../../lib/stockImportsPriceLabels'
import {
  SEGMENT_MODES_FOR_REGULAR,
  SEGMENT_MODES_FOR_RRC,
} from '../lib/configPriceModel'
import { formatColumnNumber } from './priceColumnFormat'
import {
  PriceBooleanSelectField,
  type PriceFieldContext,
  PriceSelectField,
  PriceTextField,
} from './PriceFields'
import cn from './PricesStep.module.scss'

interface SegmentRuleRowProps {
  context: PriceFieldContext
  index: number
}

function SegmentRuleRow({ context, index }: SegmentRuleRowProps) {
  const row = useWatch({ control: context.control, name: `segments.${index}` })
  const columnError = context.errors.segments?.[index]?.columnNumber?.message
  const modeOptions = (
    row.isRrc ? SEGMENT_MODES_FOR_RRC : SEGMENT_MODES_FOR_REGULAR
  ).map((mode) => ({
    value: mode,
    label: SEGMENT_PRICE_MODE_LABELS[mode].label,
  }))

  return (
    <div className={cn.segment}>
      {row.mode === 'COLUMN' && (
        <p className={cn.columnNote}>
          Цена из колонки {formatColumnNumber(row.columnNumber)} — меняется на
          шаге «Настройки» в блоке «Файл и колонки»
          {columnError && (
            <span role="alert" className={cn.error}>
              {columnError}
            </span>
          )}
        </p>
      )}
      <div className={cn.segmentParams}>
        {row.mode !== 'COLUMN' && (
          <PriceSelectField
            context={context}
            name={`segments.${index}.mode`}
            title="Способ расчёта"
            options={modeOptions}
          />
        )}
        {row.mode === 'MARKUP' && (
          <>
            <PriceBooleanSelectField
              context={context}
              name={`segments.${index}.useSegmentDefault`}
              title="Наценка по умолчанию"
              trueLabel={`Применить (${row.defaultMarkupPercent}%)`}
              falseLabel="Не применять"
            />
            <div>
              <PriceTextField
                context={context}
                name={`segments.${index}.deltaPercent`}
                title="Дополнительная надбавка, %"
              />
              {row.useSegmentDefault && row.defaultMarkupPercent === 0 && (
                <span className={cn.hint}>
                  Цена будет равна закупочной: задайте надбавку
                </span>
              )}
            </div>
          </>
        )}
        {row.mode === 'RRC_DISCOUNT' && (
          <PriceTextField
            context={context}
            name={`segments.${index}.deltaPercent`}
            title="Скидка от РРЦ, %"
          />
        )}
        {row.mode === 'COLUMN' && (
          <PriceTextField
            context={context}
            name={`segments.${index}.columnExpectedHeader`}
            title="Ожидаемый заголовок"
            placeholder="Необязательно"
          />
        )}
      </div>
    </div>
  )
}

export default SegmentRuleRow
